import React, {useEffect} from 'react';
import {createPortal} from 'react-dom';
import {NavLink} from 'react-router';
import PrivateNavLinks from './PrivateNavLinks';
import {useUser} from '../../Providers/UserInfo';

export default function MobileNavDrawer({isOpen, onClose}) {
    const {name} = useUser();

    useEffect(() => {
        if (!isOpen) {
            return undefined;
        }

        const onKeyDown = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', onKeyDown);

        return () => {
            document.body.style.overflow = previousOverflow;
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [isOpen, onClose]);

    if (!isOpen) {
        return null;
    }

    return createPortal(
        <div className="rest-mobile-nav" role="dialog" aria-modal="true" aria-label="منوی پنل">
            <button
                type="button"
                className="rest-mobile-nav__backdrop"
                onClick={onClose}
                aria-label="بستن منو"
            />

            <aside className="rest-mobile-nav__panel">
                <div className="rest-mobile-nav__accent" aria-hidden="true"/>

                <header className="rest-mobile-nav__header">
                    <NavLink to="/orders" onClick={onClose} className="rest-mobile-nav__brand">
                        <img
                            src="/images/small-logo.png"
                            alt="غذارسان"
                            className="rest-mobile-nav__logo"
                            width={40}
                            height={40}
                        />
                        <div className="rest-mobile-nav__brand-text">
                            <span className="rest-mobile-nav__brand-name">غذارسان</span>
                            <span className="rest-mobile-nav__brand-sub">پنل رستوران‌دار</span>
                        </div>
                    </NavLink>
                    {name && <p className="rest-mobile-nav__restaurant">{name}</p>}
                </header>

                <div className="rest-mobile-nav__body">
                    <PrivateNavLinks onNavigate={onClose}/>
                </div>
            </aside>
        </div>,
        document.body
    );
}
